import React from "react"
import AccountSidebarNav from "../AccountSidebarNav"
import styles from "./index.module.scss"

const AccountSettingsRightSidebar = () => {
  return (
    <div className={styles.sidebar}>
      <div className={styles.navSection}>
        <AccountSidebarNav />
      </div>
    </div>
  )
}

export default AccountSettingsRightSidebar

